module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes por aprobar")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.mostrarConfirmacionAprobar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [_vm._v("Aprobar")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [_vm._v("Rechazar")])])], 1) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('loading') : _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-2"
  }, [_vm._v("Tipo renovación")]), _c('th', [_vm._v("Estado")]), _c('th', {
    staticClass: "hide-break-2"
  }, [_vm._v("Creado por")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o) {
    return _c('tr', {
      key: o.id + '-tabla',
      staticClass: "row-table",
      class: {
        'row-info': o.esDeDelegacion
      }
    }, [_c('td', [_c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Solicitud Delegada'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "td-wrapper hint--right",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_c('div', {
      staticClass: "dates-wrapper hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', [_vm._v(_vm._s(o.nombre) + " ")])]), _c('div', {
      staticClass: "show-break-2 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Renovacion:")]), (o.indeterminado) ? _c('span', [_vm._v("Contrato Indeterminado")]) : _c('span', [_vm._v(_vm._s(o.meses) + " meses")])]), _c('div', {
      staticClass: "show-break-2 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Creador:")]), _c('span', [_vm._v(_vm._s(o.creadoPor))])])])])]), _c('td', {
      staticClass: "hide-break-2"
    }, [(o.indeterminado) ? _c('span', [_vm._v("Contrato Indeterminado")]) : _c('span', [_vm._v(_vm._s(o.meses) + " meses")])]), _c('td', [_vm._v(_vm._s(o.descripcionEstado))]), _c('td', {
      staticClass: "hide-break-2"
    }, [_vm._v(_vm._s(o.creadoPor))]), _c('td', [(o.estado === 1) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-thumbs-o-up"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()])])
  }), 0)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0be24f46","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Por_Aprobar.vue
// module id = 816
// module chunks = 0